<div class="container">

  <app-header-dialog [iconName]="'noise_control_off'">
    Formulário PDF
  </app-header-dialog>

  <div *ngIf="entityForm">

    <div class="content">

      <div style="height:120px;">

        <div style="margin-top: 10px; margin-left: 20px;">
          <div>
            <input type="file" #fileImage (change)="onFileSelected($event)" accept="application/pdf"
              style="display:none;">
            <a mat-raised-button (click)='fileImage.click()' matTooltip='Selecionar arquivo'
              style='background-color: whitesmoke;'>
              <mat-icon class='icon-add'>image_search</mat-icon>
              Selecionar arquivo
            </a>
          </div>

          <div *ngIf="selectedFileName" style="margin-top: 10px;">
            <a mat-button target="_blank" *ngIf="selectedFileName" [href]="storedPDF"
              style='background-color: whitesmoke; margin-top:  20px;'>
              {{selectedFileName}}
            </a>
          </div>
          <div *ngIf="pdfName" style="margin-top: 10px;">
            <a mat-button target="_blank" *ngIf="pdfName" [href]="storedPDF"
              style='background-color: whitesmoke; margin-top:  20px;'>
              {{pdfName}}
            </a>
          </div>

        </div>

      </div>

      <mat-form-field style='width: 100%;' appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
          autocomplete="off">
      </mat-form-field>

      <mat-form-field style='width: 100%;' appearance="outline">
        <mat-label>Chave</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.key"
          autocomplete="off">
      </mat-form-field>

    </div>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

      <button *ngIf="!isEdit"  matTooltip='Inserir' mat-raised-button (click)="matDialogRef.close(['insert', entityForm, selectedFile])"
        [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>

      <button *ngIf="isEdit" matTooltip='Alterar' mat-raised-button
        (click)="matDialogRef.close(['update', entityForm, selectedFile])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>
  

    </div>

  </div>

</div>